import type {
  AgentCancelWithdrawalFiatInput,
  AgentCalculateWithdrawalCostInput,
  AgentWithdrawFiatInput,
  AgentGetFiatTransactionHistoryInput,
} from '../api'
import { api } from '../api'
import { delayFn } from '../delay'

const initiateAgentWithdrawalFiat = async (data: AgentWithdrawFiatInput) => {
  await api.v1.agentInitiateWithdrawalFiat({
    ...data,
  })

  return await delayFn(2000)
}

const calculateAgentWithdrawalCost = async (
  data: AgentCalculateWithdrawalCostInput,
) => {
  return await api.v1.agentCalculateWithdrawalCost({
    ...data,
  })
}
const getAgentFiatTransactionHistory = async (
  data: AgentGetFiatTransactionHistoryInput,
) => {
  return await api.v1.agentGetFiatTransactionHistory({
    ...data,
  })
}
const cancelAgentWithdrawalFiat = async (
  data: AgentCancelWithdrawalFiatInput,
) => {
  return await api.v1.agentCancelWithdrawalFiat({
    ...data,
  })
}

export default {
  calculateAgentWithdrawalCost,
  getAgentFiatTransactionHistory,
  initiateAgentWithdrawalFiat,
  cancelAgentWithdrawalFiat,
}
